import React from "react";

const ProfileCard = ({ name, imageUrl }) => {
  return (
    <div className="relative w-52 h-52 rounded-lg overflow-hidden">
      <img className="w-full h-full object-cover" src={imageUrl} alt={name} />
      <div className="absolute top-2 right-2 bg-black text-white font-bold px-2 py-1 rounded text-sm">
        {name}
      </div>
    </div>
  );
};

const Coreteam = ({ name, imageUrl }) => {
  return (
    <div className="flex justify-center items-center">
      <ProfileCard name={name} imageUrl={imageUrl} />
    </div>
  );
};

export default Coreteam;
